import { isWebView } from "@/utils/common";
// 是否开启访问模式
export const openVisitorMode = uni.getStorageSync('openVisitorMode')

const baseWhitePage = [
    // 开不开都能进去的
    '/pages/author/transit',
    '/pages/author/index',
    '/pages/author/btoc',
    '/MP_verify_TdX7yqmdNNoP1lK4.txt',
    '/pages/public/error',
    '/pages/YunfuHelpNew/home',
    '/pages/YunfuHelpNew/helpLibrary',
    '/pages/goods/index',
    '/pages/index/festivals',
    '/pages/index/promotion',
    '/pages/index/jinqun',
    '/pages/index/InviteCourtesy',
    '/pages/index/InviteDilate',
    '/pages/index/Invitejieri',
    '/pages/index/index',
    '/pages/index/user',
    '/pages/index/category',
    '/pages/goods/list',
    '/pages/cakeModule/CakeHome',
    '/pages/YunfuHelp/home',
    '/pages/movie/index',
    '/pages/movie/cinema-all',
    '/pages/movie/cinema-equity',
    '/pages/equityModule/equityHome',
    '/pages/index/discount',
    '/pages/index/promotion',
    '/pages/index/kfWechat',
    '/pages/rightsCard/claim'
]

const whitePage = [
    // 开了游客才能进去的
    ...baseWhitePage,
    '/pages/index/index',
    '/pages/index/user',
    '/pages/index/category',
    '/pages/goods/list',
    '/pages/rightsCard/claim',
    '/pages/cakeModule/CakeHome',
    '/pages/YunfuHelp/home',
    '/pages/movie/index',
    '/pages/movie/cinema-all',
    '/pages/movie/cinema-equity',
    '/pages/equityModule/equityHome',
    '/pages/index/discount',
    '/pages/index/promotion',

]


export function GetWhitePages() {
    const isWeb = sessionStorage.getItem('isWeb') || ''
    const openVisitorMode = uni.getStorageSync('openVisitorMode')
    if(isWebView() || isWeb == 'isWeb') {
      return whitePage    
    }else{
      return openVisitorMode ? whitePage : baseWhitePage;
    }
}


export function IsWhitePage() {
    const path = window.location.href
    let isWhitePage = false;
    if (!path.includes('/pages')) {
        // 首页
        if (openVisitorMode) isWhitePage = true;
        else {
            if (uni.getStorageSync('token')) isWhitePage = true;
            else isWhitePage = false;
        }
    }
    else {
        const arr = GetWhitePages();
        arr.map(item => {
            if (path.includes(item)) {
                isWhitePage = true;
            }
        })
    }

    return isWhitePage;
}